import {
  FETCH_UPDATE,
  FETCH_GLOBAL_NUMBERS_SUCCESS,
  FETCH_GLOBAL_NUMBERS_FAILURE,
} from '@/store/actions';
import { 
  getConferenceCallGlobalPhoneDirectory,
  getSGMDialInDetails,
  getMGMDialInDetails
} from '@/service/api';
import { globalCommit, commitLocalAndToGlobalService, isJsonString } from '@/utils/vuex';
import Constants from '@/utils/constants';

export const GlobalNumbersModule = {
  namespaced: true,
  state: {
    globalNumbers: []
  },

  actions: {
    async fetchGlobalNumbers({ commit }, confId) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const globalNumbers = await getConferenceCallGlobalPhoneDirectory(confId);
        commitLocalAndToGlobalService(commit, FETCH_GLOBAL_NUMBERS_SUCCESS, globalNumbers.data);
    } catch (error) {
        commitLocalAndToGlobalService(commit, FETCH_GLOBAL_NUMBERS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
    }
    },
    async fetchGlobalNumbersSGM({ commit }, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const sgmDialInDetails = await getSGMDialInDetails(params.presId, params.meetingId);
        const globalNumbers = sgmDialInDetails.data.GlobalPhoneDirectory;
        commitLocalAndToGlobalService(commit, FETCH_GLOBAL_NUMBERS_SUCCESS, globalNumbers);
      } catch (error) {
        commitLocalAndToGlobalService(commit, FETCH_GLOBAL_NUMBERS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },
    async fetchGlobalNumbersMGM({ commit }, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const mgmDialInDetails = await getMGMDialInDetails(params.presId);
        const globalNumbers = mgmDialInDetails.data.GlobalPhoneDirectory;
        commitLocalAndToGlobalService(commit, FETCH_GLOBAL_NUMBERS_SUCCESS, globalNumbers);
      } catch (error) {
        globalCommit('service', commit, FETCH_UPDATE);
        throw error;
      }
    }
  },

  mutations: {
    [FETCH_GLOBAL_NUMBERS_SUCCESS] : (state, globalNumbers)=> {
      state.globalNumbers = globalNumbers;
    }
  },

  getters: {
    GET_GLOBAL_NUMBERS: state => state.globalNumbers,
  }

}
